<template>
  <div class="block-promo">
    <div class="map-links">
			<a
        @click.prevent="
					() => $emit('call-order', { title1: `MITSUBISHI OUTLANDER` })
				"
        href="#form_popup"
        class="map-link map-link--outlander"
      >
        MITSUBISHI
        <br />OUTLANDER
      </a>
      <a
        @click.prevent="
					() => $emit('call-order', { title1: `PAJERO SPORT` })
				"
        href="#form_popup"
        class="map-link map-link--pajero_sport"
      >
        MITSUBISHI
        <br />PAJERO SPORT
      </a>
      <a
        @click.prevent="() => $emit('call-order', { title1: `MITSUBISHI PAJERO 4` })"
        href="#form_popup"
        class="map-link map-link--pajero_4"
      >
        MITSUBISHI
        <br />PAJERO 4
      </a>
			<a
        @click.prevent="
					() => $emit('call-order', { title1: `MITSUBISHI X-PANDER` })
				"
        href="#form_popup"
        class="map-link map-link--x_pander"
      >
        MITSUBISHI
        <br />X-PANDER
      </a>
    </div>
    <div class="container">
      <div class="block-promo__inner">
        <div class="block-promo__info-container">
          <div class="block-promo__title">
            ФИНАЛЬНАЯ АКЦИЯ
            <br />НА MITSUBISHI В НАЛИЧИИ
          </div>
          <div class="block-promo__comment">
            ТОЛЬКО 3 ДНЯ В РОЛЬФ
            <br />{{ getTextByDate }}
          </div>
        </div>
        <div class="list btns_container">
          <div v-for="item in promoData" :key="item.id" class="btns_item">
            <a
              @click.prevent="() => getOffer({ title1: item.msg })"
              class="btn-transparent block-promo__btn--transparent"
              href="#form_popup"
            >{{ item.msg }}</a>

            <!-- <a
              v-if="item.price"
              @click.prevent="
								() => getOffer({ title1: item.price, ['title2-through']: item.line_through_fos })
							"
              class="btn-red"
              :class="{ 'line-through': false }"
              href="#form_popup"
            >{{ item.price }}</a> -->

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import promoData from "../common/promo-data";

export default {
  name: "promo-block",
  data() {
    return {
      promoData,
    };
  },
  computed: {
    getTextByDate() {
      let today = new Date()
      let targetDate = new Date(2023, 7, 7)

      let text = targetDate.getTime() < today.getTime() ?
        'ПОСЛЕДНИЕ АВТОМОБИЛИ ПО АКЦИИ' :
        'УСПЕЙТЕ ДО ПОДОРОЖАНИЯ!'

      return text
    },
  },
  methods: {
    getOffer(title) {
      this.$emit("call-order", title);
    },
  },
};
</script>

<style lang="scss" scoped>
.line-through {
  text-decoration: line-through;
}

.block-promo {
  background: white url("../img/background/bg-new.jpg") no-repeat;
  background-position-y: 45%;
  background-position-x: 60%;
  position: relative;
  height: 700px;
  // margin-top: 100px;

  @media (max-width: 1250px) {
    height: 600px;
    background-size: auto 600px;
  }

  @media (max-width: 800px) {
    margin-top: 0;
  }

  @media (max-width: 768px) {
    background-size: 160%;
    background-position-y: top;
    height: auto;
  }

  @media (max-width: 991px) and (min-width: 768px) {
    // background: white top no-repeat;
    background-size: 160%;
  }

  &__btn--transparent {
    @media (min-width: 768px) and (max-width: 991px) {
      color: #fff;

      background-color: #a8a8a8;
    }

    &:hover {
      // color: #ddd;

      // background-color: transparent;
      // border: 2px solid #ddd;

        background: #686d71;
        border-color: #686d71;
        color: #fff;
    }
  }
}

.container {
  margin: 0px auto;
  max-width: 1240px;
  position: relative;
  padding: 0px 15px;
  text-align: center;
  height: 100%;
}

.btn.transgray {
  background: transparent;
  border-color: #a8a8a8;
  color: #a8a8a8;

  &:hover {
    border-color: #cdcdcd;
    color: #cdcdcd;
  }
}

.block-promo__inner {
  margin: 0 auto;
  height: 100%;
  display: flex;
  flex-direction: column;

  @media (max-width: 380px) {
    width: 100%;
  }

  @media (max-width: 991px) and (min-width: 768px) {
    width: 100%;
    margin: 0 auto;
  }
}

.block-promo__info-container {
  //   background: rgba(0, 0, 0, 0.5);
  width: 60%;
  padding-left: 10px;
  margin-top: 10px;
  @media (max-width: 1250px) {
    width: 52%;
    margin-top: 5px;
  }
  @media (max-width: 1050px) {
    width: 60%;
  }
  @media (max-width: 991px) {
    margin-top: 23px;
    width: 70%;
  }
  @media (max-width: 768px) {
    margin-top: 57%;
    width: 100%;
    padding-left: 0;
    // background: none;
  }
  @media (max-width: 380px) {
    margin-top: 200px;
  }
  @media (max-width: 320px) {
    margin-top: 170px;
  }
}

.block-promo__title {
  color: white;
  font-size: 50px;
  font-weight: 700;
  //   padding-top: 20px;
  padding-top: 10px;
  padding-bottom: 20px;
  text-align: left;
  text-shadow: 0 0 20px rgba(0, 0, 0, 0.7);
  @media (max-width: 991px) {
    font-size: 48px;
    padding-top: 0;
  }

  @media (max-width: 768px) {
    color: #ee0000;
    text-align: center;
    font-size: 43px;
    font-weight: 700;
    // padding-top: 57%;
    padding-bottom: 20px;

    br {
      display: none;
    }
  }
  @media (max-width: 380px) {
    font-size: 38px;
    // padding-top: 200px;
  }
  @media (max-width: 320px) {
    font-size: 32px;
    padding-top: 170px;
  }
}

.block-promo__comment {
  color: white;
  font-size: 26px;
  font-weight: 700;
  //   padding-bottom: 32px;
  padding-bottom: 10px;
  text-align: left;
  text-shadow: 0 0 20px rgba(0, 0, 0, 0.7);

  @media (max-width: 320px) {
    font-size: 18px;
  }

  @media (max-width: 768px) {
    color: black;
    text-align: center;
    padding-bottom: 0;
  }

  //   @media (max-width: 991px) and (min-width: 768px) {
  //     padding-bottom: 260px;
  //   }
}

.block-promo__comment span {
  font-size: 35px;
}

.block-promo__inner .btns_container {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding-left: 6%;
  margin-top: 33%;

  @media (max-width: 1250px) {
  margin-top: 25%;
  }

  @media (max-width: 768px) {
    display: none;
  }
}

.block-promo__inner .btns_item {
  width: 23%;
  max-width: 220px;
}

.btns_item:nth-child(2) {
  margin: 0 60px;
  @media (max-width: 1250px) {
  margin: 0;
  }
}

.btns_item:nth-child(4) {
  margin-right: -20px;
}

.block-promo__inner .btns_item a:first-child {
  margin-bottom: 10px;
}

.map-link {
  opacity: 0;
  position: absolute;
  display: block;
  width: 140px;
  height: 60px;
  cursor: pointer;
  z-index: 2;
  color: #fff;
  text-align: center;
  &--outlander {
    right: 55.3%;
    top: 37%;
    transform: translateX(-366px);
  }
  &--pajero_sport {
    right: 55%;
    top: 35%;
    transform: translateX(-20px);
  }
  &--pajero_4 {
    right: 56%;
    top: 32%;
    transform: translateX(310px);
    width: 150px;
  }
  &--x_pander {
    right: 53.5%;
    top: 30%;
    width: 170px;
    transform: translateX(600px);
  }

  @media (max-width: 1250px) {
    font-size: 14px;

    &--outlander {
      top: 225px;
      transform: translateX(-366px);
    }
    &--pajero_sport {
      top: 225px;
      transform: translateX(-80px);
    }
    &--pajero_4 {
      top: 197px;
      transform: translateX(210px);
    }
    &--x_pander {
      top: 184px;
      transform: translateX(470px);
    }
  }

  @media (max-width: 991px) {
    /* width: 12%; */

    &--outlander {
      left: 3%;
      top: calc(190px + 4vw);
      transform: translateX(0);
    }
    &--pajero_sport {
      left: 30%;
      top: calc(190px + 4vw);
      transform: translateX(0);
    }
    &--eclipse_cross {
      right: 30%;
      top: calc(190px + 4vw);
      transform: translateX(0);
    }
    &--outlander7 {
      right: 3%;
      top: calc(190px + 4vw);
      transform: translateX(0);
    }
  }
  @media (max-width: 768px) {
    /* width: 12%; */
    width: 70px;
    font-size: 12px;
    height: 5%;

    &--outlander {
      left: 8%;
      top: 17vw;
      transform: translateX(-50%);
    }
    &--pajero_sport {
      left: 37%;
      top: 17vw;
      transform: translateX(-50%);
    }
    &--eclipse_cross {
      width: 90px;
      right: 36.5%;
      top: 17vw;
      transform: translateX(50%);
    }
    &--outlander7 {
      width: 100px;
      right: 13%;
      top: 17vw;
      transform: translateX(50%);
    }
  }
  @media (max-width: 500px) {
    font-size: 2vw;
  }
}
</style>
